var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("ServiceDashboard"),
      _vm._v(" "),
      _c("SuperuserTransferSessionModal"),
      _vm._v(" "),
      _c("SuperuserFailedTransferSessionModal"),
      _vm._v(" "),
      _c("ScrollToTop"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }